<template>
  <base-modal
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Save"
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="modal-footer-custom"
    header-class="modal-header-custom"
    body-class="modal-body-custom"
    content-class="modal-content-custom"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="mb-6 pb-6 border-b border-border">
        <div class="text-[11px] font-semibold uppercase tracking-wide text-muted mb-4">Personal info</div>
        <div class="flex gap-4">
          <div class="mb-4 flex-1"><label for="firstName" class="block text-[13px] font-medium text-ink mb-1.5">First name</label>
            <input
              id="firstName"
              v-model="contact.firstName"
              required
              placeholder="John"
              class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
            >
          </div>

          <div class="mb-4 flex-1"><label for="lastName" class="block text-[13px] font-medium text-ink mb-1.5">Last name</label>
            <input
              id="lastName"
              v-model="contact.lastName"
              required
              placeholder="Doe"
              class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
            >
          </div>
        </div>

        <div class="mb-4"><label for="shortDescription" class="block text-[13px] font-medium text-ink mb-1.5">Short description</label>
          <input
            id="shortDescription"
            v-model="contact.shortDescription"
            placeholder="e.g. Immigration Lawyer"
            class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
          >
        </div>

        <div class="mb-4"><label for="description" class="block text-[13px] font-medium text-ink mb-1.5">Description</label>
          <textarea
            id="description"
            v-model="contact.description"
            placeholder="Detailed background..."
            rows="3"
            max-rows="10"
            class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
          </textarea>
        </div>
      </div>

      <div class="mb-6 pb-6 border-b border-border">
        <div class="text-[11px] font-semibold uppercase tracking-wide text-muted mb-4">Application</div>
        <div class="flex gap-4">
          <div class="mb-4 flex-1"><label for="type" class="block text-[13px] font-medium text-ink mb-1.5">Application type</label>
            <base-select v-model="contact.type" :options="applicationTypes" value-key="value" label-key="text" placeholder="Select type"></base-select>
          </div>

          <div class="mb-4 flex-1"><label for="endorsingBody" class="block text-[13px] font-medium text-ink mb-1.5">Endorsing body</label>
            <base-select v-model="contact.endorsingBody" :options="bodies" value-key="slug" label-key="title" placeholder="Select body"></base-select>
          </div>
        </div>
      </div>

      <div class="mb-6 pb-6 border-b border-border">
        <div class="text-[11px] font-semibold uppercase tracking-wide text-muted mb-4">Media</div>
        <div class="mb-4"><label for="picture" class="block text-[13px] font-medium text-ink mb-1.5">Picture filename</label>
          <input
            id="picture"
            v-model="contact.picture"
            placeholder="photo.jpg"
            class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
          >
        </div>
      </div>

      <div>
        <div class="text-[11px] font-semibold uppercase tracking-wide text-muted mb-4">Settings</div>
        <div class="flex gap-4">
          <div class="mb-4 flex-1"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Status</label>
            <base-select v-model="contact.isActive" :options="statusOptions" value-key="value" label-key="text" placeholder="Select status"></base-select>
          </div>

          <div class="mb-4 flex-1"><label for="payment" class="block text-[13px] font-medium text-ink mb-1.5">Payment</label>
            <base-select v-model="contact.paid" :options="contactPaymentOptions" value-key="value" label-key="text" placeholder="Select payment"></base-select>
          </div>
        </div>

        <div class="mb-4" v-if="user.isAdmin"><label for="availableTo" class="block text-[13px] font-medium text-ink mb-1.5">Available to</label>
          <select v-model="contact.availableTo" multiple class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"><option v-for="opt in managers" :key="opt.value !== undefined ? opt.value : opt" :value="opt.value !== undefined ? opt.value : opt">{{ opt.text !== undefined ? opt.text : opt }}</option></select>
        </div>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import BaseSelect from '../../UIComponents/BaseSelect'

export default {
  components: { BaseSelect },
  props: {
    item: [Object]
  },
  data () {
    return {
      contact: {
        firstName: '',
        lastName: '',
        createdAt: '',
        isActive: true,
        paid: false,
        description: '',
        shortDescription: '',
        type: '',
        endorsingBody: '',
        availableTo: [],
        picture: ''
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      statusOptions: state => state.auth.statusOptions,
      contactPaymentOptions: state => state.contacts.contactPaymentOptions,
      applicationTypes: state => state.auth.applicationTypes,
      bodies: state => state.managers.bodies,
      managers: state => state.managers.managers.filter(m => !m.hidden)
    }),
    title () {
      if (this.item) {
        return 'Edit contact'
      } else {
        return 'Add contact'
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      const { contact } = this
      if (this.item) {
        this.$store.dispatch('UPDATE_CONTACT', contact).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      } else {
        this.contact.createdAt = dayjs().format()
        this.$store.dispatch('CREATE_CONTACT', { contact }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      }
    },
    resetModal () {
      this.contact.id = ''
      this.contact.firstName = ''
      this.contact.lastName = ''
      this.contact.createdAt = ''
      this.contact.isActive = true
      this.contact.paid = false
      this.contact.description = ''
      this.contact.shortDescription = ''
      this.contact.type = ''
      this.contact.endorsingBody = ''
      this.contact.deadline = ''
      this.contact.picture = ''
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.contact.id = this.item.id || ''
        this.contact.firstName = this.item.firstName ? this.item.firstName : ''
        this.contact.lastName = this.item.lastName ? this.item.lastName : ''
        this.contact.createdAt = this.item.createdAt ? this.item.createdAt : ''
        this.contact.isActive = this.item.isActive ? this.item.isActive : true
        this.contact.paid = this.item.paid ? this.item.paid : false
        this.contact.description = this.item.description ? this.item.description : ''
        this.contact.shortDescription = this.item.shortDescription ? this.item.shortDescription : ''
        this.contact.type = this.item.type ? this.item.type : ''
        this.contact.endorsingBody = this.item.endorsingBody ? this.item.endorsingBody : ''
        this.contact.availableTo = this.item.availableTo ? this.item.availableTo : []
        this.contact.picture = this.item.picture ? this.item.picture : ''
      }
    },
    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>

